import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getClusterGrid(context) {
      const response = await Vue.axios.get(`${URL_API}clustergrid`);
      let data = response["data"];
      context.commit("updateClusterGrid", data);
      return data;
    },
    async createClusterGrid(context, { geometry, name, color }) {
      const config = {};
      const body = {};
      if (geometry) body.geometry = geometry;
      if (name) body.name = name;
      if (color) body.color = color;

      try {
        await Vue.axios.post(`${URL_API}clustergrid/store`, body, config);
        context.dispatch("getClusterGrid");
        context.commit("updateClusterMsg", 1);
      } catch (error) {
        context.commit("updateClusterMsg", 0);
      }
    },
    async pushClusterGrid(context, { id, geometry = null, name, color }) {
      const config = {};
      const body = { id: id };
      if (geometry) body.geometry = geometry;
      if (name) body.name = name;
      if (color) body.color = color;

      try {
        await Vue.axios.post(`${URL_API}clustergrid/update`, body, config);
        context.dispatch("getClusterGrid");
        context.commit("updateClusterMsg", 1);
      } catch (error) {
        context.commit("updateClusterMsg", 0);
      }
    },
    async destroyClusterGrid(context, id) {
      const config = {};
      const body = {
        id: id
      };
      try {
        await Vue.axios.post(`${URL_API}clustergrid/destroy`, body, config);
        context.dispatch("getClusterGrid");
        context.commit("updateClusterMsg", 1);
      } catch (error) {
        context.commit("updateClusterMsg", 0);
      }
    }
  },
  mutations: {
    updateClusterGrid(state, clusterGrid) {
      state.clusterGrid = clusterGrid;
    },
    updateClusterMsg(state, data) {
      state.clusterMsg = data;
    }
  },
  state: {
    clusterGrid: {},
    clusterMsg: null
  },
  getters: {
    allClusterGrid(state) {
      return state.clusterGrid;
    }
  }
};
